/** @typedef {import("../../api/types").DeviceType} DeviceType */
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import {Alert, Button, Card, CardBody, Container, Spinner} from "reactstrap";
import FieldTags from "./components/FieldTags";
import ListLink from "../../shared/components/ListLink";
import IconLabel from "../../shared/components/IconLabel";
import {PencilIcon} from "../../shared/components/icons";

const DEVICE_TYPES_URL = "/os/api/device_types/";

const DeviceTypeDetail = () => {
    const {id} = useParams();
    const [deviceType, setDeviceType] = useState(/** @type {DeviceType|null} */ (null));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError(null);
        setDeviceType(null);

        axios
            .get(`${DEVICE_TYPES_URL}${encodeURIComponent(id)}/`, {signal: controller.signal})
            .then(({data}) => setDeviceType(data))
            .catch((err) => {
                if (axios.isCancel(err)) return;
                setError(
                    err.response?.status === 404
                        ? "Tipo de equipamento não encontrado."
                        : "Não foi possível carregar o tipo de equipamento."
                );
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [id]);

    return (
        <Container className="mt-4 mb-5">
            <ListLink basePath="/device-types">&larr; Tipos de equipamento</ListLink>
            {loading && (
                <div className="text-center mt-4">
                    <Spinner />
                </div>
            )}
            {error && (
                <Alert color="danger" className="mt-3">
                    {error}
                </Alert>
            )}
            {deviceType && (
                <>
                    <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                        <h3 className="mb-0">{deviceType.name}</h3>
                        <Button color="primary" outline tag={Link} to={`/device-types/${id}/edit`}>
                            <IconLabel icon={<PencilIcon size={16} />}>Editar</IconLabel>
                        </Button>
                    </div>
                    <Card>
                        <CardBody>
                            <div className="mb-3">
                                <div className="small text-muted">Descrição</div>
                                <div style={{whiteSpace: "pre-wrap"}}>{deviceType.description}</div>
                            </div>
                            <div>
                                <div className="small text-muted">Campos</div>
                                <FieldTags fieldsList={deviceType.fields_list} />
                            </div>
                        </CardBody>
                    </Card>
                </>
            )}
        </Container>
    );
};

export default DeviceTypeDetail;
